import { render, staticRenderFns } from "./LostCardForm.vue?vue&type=template&id=144f9981&scoped=true"
import script from "./LostCardForm.vue?vue&type=script&lang=js"
export * from "./LostCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f9981",
  null
  
)

export default component.exports